// FOR DEV:
// export const API_BASE_URL = "http://127.0.0.1:8000/api";

// FOR PROD:
export const API_BASE_URL = "https://lamig-saln.online/api";